import React from 'react'
import Footer from "../Components/Footer"
import { Helmet } from "react-helmet"
import { AiOutlineArrowLeft } from 'react-icons/ai'



const School9 = () => {
    return (
        <>
        <div className='max-w-[1240px] mx-auto my-3'>
            <Helmet>
                <script src="https://cdn.jsdelivr.net/npm/publicalbum@latest/embed-ui.min.js" async></script>
            </Helmet>
            <a className='go-back flex gap-3 text-semibold text-lg pl-3 mt-7' href='/gallery'><AiOutlineArrowLeft size={30}/>Назад в галерею</a>
            <h3 className='font-medium text-lg text-center py-2'>Школа №9</h3>
            <div className="pa-gallery-player-widget mx-auto" style={{ width: `80%`, height: `400px`, display: `none` }}
                data-link="https://photos.app.goo.gl/jEZRFg9bC8e28y8R9"
                data-title="Школа №9"
                data-description="7 new items added to shared album">
                <object data="https://lh3.googleusercontent.com/Cm4DgEhWv_bbkcqwfIbKCWqVLAfvpfRnelbVwyFn3nQCzhrZN85n-Xh8rl0gqAeqgpjKajO2BwMQbAruqNJ55uJRMG3OvZLrNXv6VWDL25xQKMbscbeGJ4afqG8Tp7rU9A0L72giIA=w1920-h1080"></object>
                <object data="https://lh3.googleusercontent.com/1w9x6rsuVhTMYQROfCNzHDJf6MAUEURh3lo094BAcTbu0p6AsRfUgQ7NElgvu61UJibWkyTEPXeWRFOXnrygPBuc3-F0f3Ozk0nTgXNZQiVIBnObFWOTeTFi9Qaxuj7aWA0o4fi5Yw=w1920-h1080"></object>
                <object data="https://lh3.googleusercontent.com/Jpjqvla4OtewGawAarIrVAOLzcX-EloaNV2AhZa2y8zNu5KLf0P9ii_2Iz6dixIxVEc2BxSLY7ksy1LMAlN4tcg6mVfboIGK91BSYyZRHwhQXrJDIFqZrv1rgqoN5o3Ta1uTxfxunA=w1920-h1080"></object>
                <object data="https://lh3.googleusercontent.com/LuZlsG0ahTM-XYPaRlNv5_jC1c9D3TNe6IOlymPzikNxq15ZG_LcS-TQhDOBHPPceQBDkLvRajdYIRi28BsI5eeLDeTs6qlUwXUqLc3-mJzslDVIOJmPQF-Kd66zKb9NTN3NEuZHzw=w1920-h1080"></object>
                <object data="https://lh3.googleusercontent.com/E5fZgToDViacV8YcNnMmLaBfEhyBVSkN5fuKsmmklgqFg-bm_Deuei3OOo09BcUtTKQ07FGB0XNmnt3Sz1L3jSr_lFJTFDomxLYyh436HVhsSXSh5i-BoO0wF2J07LsZt8QBq5nUug=w1920-h1080"></object>
                <object data="https://lh3.googleusercontent.com/32cs-5mcqFCQ7utIubCMuonVClDl7wLFH2_EHmPsb7FcOJ5xvvCd9NO9Y3ARbc27PCP5cSEvKAGICRhCsYqvaRNzZQ3vF7tP6NU36IaQX06Z9wKp1Zdls9x7zyho3qm1eKdhiYXcyw=w1920-h1080"></object>
                <object data="https://lh3.googleusercontent.com/Smmti_05DNUgBmBLmVBao2st5_Ws5r2hfny-C6H-oCyDxI_S2hhWHR8MkB4mO53rNh0ktNfwVAwwrNhRPTDC2qyJ9g_8CVLco1NLeTGiMmfZRL0W0YQFNf_XJlwStl7gEtII96iPVw=w1920-h1080"></object>
            </div>
        </div>
        <Footer />
        </>
    )
}

export default School9